export const checkPermission = (permission, returnChildren = false) => {
  if (!permission) return false;
  if (permission === true) return true;
  if (typeof permission === 'object') return returnChildren ? permission : true;
  return false;
};
